import { commitMutation, graphql } from 'react-relay';
import environment from '../../../../environment';

const mutation = graphql`
  mutation randomizePickemAnswerMutation($input: randomizePickemAnswerInput!) {
    randomizePickemAnswer(input: $input) {
      code
      message
      data {
        _id
        question_id
        guest_id
        game_id
        quarter_id
        answer
        correct_answer_count
        is_tiebreaker
      }
    }
  }
`;

/**
 *
 * @param {Object} data
 * @param {Number} callback
 */
function randomizePickemAnswer(data, callback) {
  const variables = {
    input: {
      randomizePickemAnswerInput: data,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err),
  });
}

export default randomizePickemAnswer;
